<template>
  <a :href="url" target="_blank">{{ text }}</a>
</template>

<script>
import parse from 'url-parse';

export default {
  name: 'CompanySite',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    text() {
      return parse(this.url, {}).hostname;
    },
  },
};
</script>
